// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"c0673ff1","710":"b4a03499"}[chunkId] + ".js";
};